import { useState } from "react";

/**
 * hook for managing a form level error message and whether it has been acknowledged
 * onErrorAcknowledged - should be called when the error has been acknowledged by the user
 * E.g. if the user closes the dialog or submits the form again
 */
export const useErrorMessage = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorAcknowledged, setErrorAcknowledged] = useState(true);

  return {
    errorMessage,
    errorAcknowledged,
    onError: message => {
      setErrorMessage(message);
      setErrorAcknowledged(false);
    },
    onErrorAcknowledged: () => {
      setErrorAcknowledged(true);
      setErrorMessage();
    }
  };
};
